import React, { useEffect, useState } from "react";
import BookingDataService from "../../services/Booking";
import { useNavigate } from "react-router-dom";
import { SingleBookingRow } from "../../components/List/SingleBookingRow";
import { SetPageSizeModal } from "../../components/Modals/SetPageSizeModal";
import { background, useDisclosure, useToast } from "@chakra-ui/react";
import { FiSettings } from "react-icons/fi";
import { AiFillLock, AiFillUnlock } from "react-icons/ai";
import { SlCalender } from "react-icons/sl";
import { BsInfoCircleFill } from "react-icons/bs";
import BookingDateModal from "../../components/Modals/BookingDateModal";
export const BookingList = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const token = localStorage.getItem("logged_in_user_token");
  // local
  const localBookingTypeFilter =
    localStorage.getItem("booking-list-filter-type-content") || "";
  const localBookingSortFilter =
    localStorage.getItem("booking-list-filter-sort-content") || "bought";
  const localBookingStatusFilter =
    localStorage.getItem("booking-list-filter-status-content") || "";
  const localPreBookingStatusFilter =
    localStorage.getItem("booking-list-filter-pre-status-content") || "";
  const localSearch = localStorage.getItem("booking-list-search-content") || "";
  const localPagesize = localStorage.getItem("booking-list-pageSize-content");

  const localFilteredDate = localStorage.getItem("booking-list-filter-date");
  const newLocalFilteredDate = localFilteredDate
    ? JSON.parse(localFilteredDate)
    : { filterType: "", date: "" };
  const newlocalPagesize = localPagesize ? JSON.parse(localPagesize) : 10;

  const [dateValue, setDateValue] = useState(newLocalFilteredDate.date);
  const [dateTypevalue, setDateTypeValue] = useState(
    newLocalFilteredDate.filterType
  );
  const [bookingStatus, setBookingStatus] = useState(localBookingStatusFilter);
  const [preBookingStatus, setPreBookingStatus] = useState(
    localPreBookingStatusFilter
  );
  const [bookingType, setBookingType] = useState(localBookingTypeFilter);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [list, setList] = useState<any>();
  const [pageSize, setPageSize] = useState(newlocalPagesize);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [dateType, setDateType] = useState(localBookingSortFilter);
  const [search, setSearch] = useState(localSearch);
  const [corporate, setCorporate] = useState("");
  const [modal, setModal] = useState<any>("");
  const [totalBookings, setTotalBookings] = useState(0);
  const [recentBookings, setRecentBookings] = useState(0);
  const [currentMonthBookings, setcurrentMonthBookings] = useState(0);
  const isNgodelete = (isdelete: true) => {
    fetchData();
  };
  // lock
  const [lock, setLock] = useState({
    filterStatusLock: localBookingStatusFilter !== "" ? true : false,
    filterPreStatusLock: localPreBookingStatusFilter !== "" ? true : false,
    filterTypeLock: localBookingTypeFilter !== "" ? true : false,
    sortingLock: localBookingSortFilter !== "" ? true : false,
    searchLock: localSearch !== "" ? true : false,
    pageSizeLock: newlocalPagesize !== 10 ? true : false,
    filterDateLock: localFilteredDate ? true : false,
  });

  const getFilteredDate = (
    date: string,
    dateType: string,
    lockValue: boolean
  ) => {
    let formattedDate = date;
    if (dateType === "session_date") {
      formattedDate = convertSessionDateFormat(date);
    } else if (dateType === "booking_date") {
      formattedDate = convertBookingDateFormat(date);
    } else {
      formattedDate = date;
    }
    setDateValue(formattedDate);
    // setPage(1);
    setDateTypeValue(dateType);
    setLock({ ...lock, filterDateLock: lockValue });
    BookingDataService.getBookings(
      page,
      pageSize,
      dateType,
      search,
      bookingType,
      bookingStatus,
      preBookingStatus,
      dateType,
      formattedDate,
      corporate,
      token
    )
      .then((res: any) => {
        setList(res.data.data);
        setTotalPages(res.data.totalPages);
        setTotalBookings(res.data.totalBookings);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  function convertBookingDateFormat(inputDate: string) {
    const [year, month, day] = inputDate.split("-");

    const formattedDate = `${parseInt(month)}/${parseInt(day)}/${year}`;

    return formattedDate;
  }

  function convertSessionDateFormat(inputDate: string) {
    const [year, month, day] = inputDate.split("-");
    const formattedDate = `${month}/${day}/${year}`;

    return formattedDate;
  }

  const handlePageSize = (input: number, islock: boolean) => {
    setLock({ ...lock, pageSizeLock: islock });
    setPageSize(input);
  };
  const fetchData = async () => {
    BookingDataService.getBookings(
      page,
      pageSize,
      dateType,
      search,
      bookingType,
      bookingStatus,
      preBookingStatus,
      dateTypevalue,
      dateValue,
      corporate,
      token
    )
      .then((res: any) => {
        setList(res.data.data);
        setTotalPages(res.data.totalPages);
        setTotalBookings(res.data.totalBookings);
        setRecentBookings(res.data.recentBookings);
        setcurrentMonthBookings(res.data.currentMonthBookings);
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  useEffect(() => {
    fetchData();
  }, [page, pageSize]);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Bookings - Quick View</div>
      <div className="p-4">
        {/* Top section */}
        <div className="top_section_container">
          <div className="top_section_lower_container wide_item  ">
            <div className="nested p-lg-0">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => navigate("/provisional/bookings")}
                >
                  Provisional Booking List
                </button>
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => navigate("/bookings/masterview")}
                >
                  Master Booking List
                </button>
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => {
                    setModal("setPageSize");
                    onOpen();
                  }}
                >
                  <FiSettings style={{ fontSize: "20px", margin: "0 5px" }} />
                </button>
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => {
                    setModal("filterDate");
                    onOpen();
                  }}
                >
                  <SlCalender style={{ fontSize: "20px", margin: "0 5px" }} />
                </button>
                {modal === "setPageSize" && (
                  <SetPageSizeModal
                    isOpen={isOpen}
                    onClose={onClose}
                    input={pageSize}
                    isLocked={lock.pageSizeLock}
                    func={handlePageSize}
                  />
                )}
                {modal === "filterDate" && (
                  <BookingDateModal
                    Data={newLocalFilteredDate}
                    isLock={lock.filterDateLock}
                    isOpen={isOpen}
                    onClose={onClose}
                    func={getFilteredDate}
                  />
                )}
              </div>
            </div>
            <div className="nested p-lg-0">
              <div className="parent-booking-count pt-5">
                <div className="info-icon">
                  <BsInfoCircleFill color="#fdb508" fontSize="24px" />
                </div>
                <div className="info-content p-3 bg-light ml-2">
                  <div className="booking-text">
                    Bookings we had today :{" "}
                    <span className="booking-count">{recentBookings}</span>
                  </div>
                  <div className="booking-text">
                    Bookings we had this month :{" "}
                    <span className="booking-count">
                      {currentMonthBookings}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="top_section_lower_container ">
            <div className="nested p-lg-0">
              <div className="input-group">
                <input
                  className="form-control filter-sec"
                  id="lead_status"
                  placeholder="Search by email, phone or name."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                />

                <div className="input-group-append ">
                  {lock.searchLock ? (
                    <button
                      className="btn action-btn"
                      style={{ backgroundColor: "#308888" }}
                      type="button"
                      onClick={() => {
                        setLock({ ...lock, searchLock: false });
                        setSearch("");
                        localStorage.removeItem(
                          "assessment-list-filter-content"
                        );
                      }}
                    >
                      <AiFillLock
                        style={{ fontSize: "20px", margin: "0 5px" }}
                      />
                    </button>
                  ) : (
                    <button
                      className="btn action-btn"
                      style={{ backgroundColor: "#308888" }}
                      type="button"
                      onClick={() => {
                        setLock({ ...lock, searchLock: true });
                        localStorage.setItem(
                          "booking-list-search-content",
                          search
                        );
                      }}
                    >
                      <AiFillUnlock
                        style={{ fontSize: "20px", margin: "0 5px" }}
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="nested p-lg-0">
              <div className="input-group">
                <select
                  className="form-control filter-sec"
                  id="lead_status"
                  value={bookingType}
                  onChange={(e) => {
                    setBookingType(e.target.value);
                  }}
                >
                  <option value="">Select Session Type</option>
                  <option value="video">Video</option>
                  <option value="call">Audio</option>
                  <option value="chat">Chat</option>
                  <option value="inperson">Offline</option>
                </select>

                <div className="input-group-append ">
                  {lock.filterTypeLock ? (
                    <button
                      className="btn action-btn"
                      style={{ backgroundColor: "#308888" }}
                      type="button"
                      onClick={() => {
                        setLock({ ...lock, filterTypeLock: false });
                        setBookingType("");
                        localStorage.removeItem(
                          "booking-list-filter-type-content"
                        );
                      }}
                    >
                      <AiFillLock
                        style={{ fontSize: "20px", margin: "0 5px" }}
                      />
                    </button>
                  ) : (
                    <button
                      className="btn action-btn"
                      style={{ backgroundColor: "#308888" }}
                      type="button"
                      onClick={() => {
                        setLock({ ...lock, filterTypeLock: true });
                        localStorage.setItem(
                          "booking-list-filter-type-content",
                          bookingType
                        );
                      }}
                    >
                      <AiFillUnlock
                        style={{ fontSize: "20px", margin: "0 5px" }}
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="nested p-lg-0 ">
              <div className="input-group">
                <select
                  className="form-control filter-sec"
                  id="lead_status"
                  value={bookingStatus}
                  onChange={(e) => {
                    setBookingStatus(e.target.value);
                  }}
                >
                  <option value="">Select Session Status</option>
                  <option value="NO_SHOW">No Show</option>
                  <option value="SUCCESSFUL">Successful</option>
                  <option value="RESCHEDULED">Rescheduled</option>
                  <option value="PARTIAL_SESSION">Partial Session</option>
                  <option value="EXPERT_LEVEL_ISSUE">Expert Level Issue</option>
                  <option value="USER_LEVEL_ISSUE">User Level Issue</option>
                </select>

                <div className="input-group-append ">
                  {lock.filterStatusLock ? (
                    <button
                      className="btn action-btn"
                      style={{ backgroundColor: "#308888" }}
                      type="button"
                      onClick={() => {
                        setLock({ ...lock, filterStatusLock: false });
                        setBookingStatus("");
                        localStorage.removeItem(
                          "booking-list-filter-status-content"
                        );
                      }}
                    >
                      <AiFillLock
                        style={{ fontSize: "20px", margin: "0 5px" }}
                      />
                    </button>
                  ) : (
                    <button
                      className="btn action-btn"
                      style={{ backgroundColor: "#308888" }}
                      type="button"
                      onClick={() => {
                        setLock({ ...lock, filterStatusLock: true });
                        localStorage.setItem(
                          "booking-list-filter-status-content",
                          bookingStatus
                        );
                      }}
                    >
                      <AiFillUnlock
                        style={{ fontSize: "20px", margin: "0 5px" }}
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="top_section_lower_container ">
            <div className="nested p-lg-0 ">
              <div className="input-group">
                <select
                  className="form-control filter-sec"
                  id="lead_status"
                  value={preBookingStatus}
                  onChange={(e) => {
                    setPreBookingStatus(e.target.value);
                  }}
                >
                  <option value="">Select Pre Session Status</option>
                  <option value="BOOKED">Booked</option>
                  <option value="RESCHEDULED">Rescheduled</option>
                  <option value="PENDING">Pending</option>
                  <option value="CANCELLED">Cancelled</option>
                </select>

                <div className="input-group-append ">
                  {lock.filterPreStatusLock ? (
                    <button
                      className="btn action-btn"
                      style={{ backgroundColor: "#308888" }}
                      type="button"
                      onClick={() => {
                        setLock({ ...lock, filterPreStatusLock: false });
                        setPreBookingStatus("");
                        localStorage.removeItem(
                          "booking-list-filter-pre-status-content"
                        );
                      }}
                    >
                      <AiFillLock
                        style={{ fontSize: "20px", margin: "0 5px" }}
                      />
                    </button>
                  ) : (
                    <button
                      className="btn action-btn"
                      style={{ backgroundColor: "#308888" }}
                      type="button"
                      onClick={() => {
                        setLock({ ...lock, filterPreStatusLock: true });
                        localStorage.setItem(
                          "booking-list-filter-pre-status-content",
                          preBookingStatus
                        );
                      }}
                    >
                      <AiFillUnlock
                        style={{ fontSize: "20px", margin: "0 5px" }}
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="nested p-lg-0 ">
              <div className="input-group">
                <select
                  className="form-control filter-sec"
                  id="lead_status"
                  value={dateType}
                  onChange={(e) => {
                    setDateType(e.target.value);
                  }}
                >
                  <option value="">Please select</option>
                  <option value="booking">Sort by booking date</option>
                  <option value="bought">Sort by bought date</option>
                  <option value="session">Sort by session date</option>
                </select>

                <div className="input-group-append ">
                  {lock.sortingLock ? (
                    <button
                      className="btn action-btn"
                      style={{ backgroundColor: "#308888" }}
                      type="button"
                      onClick={() => {
                        setLock({ ...lock, sortingLock: false });
                        setDateType("");
                        localStorage.removeItem(
                          "booking-list-filter-sort-content"
                        );
                      }}
                    >
                      <AiFillLock
                        style={{ fontSize: "20px", margin: "0 5px" }}
                      />
                    </button>
                  ) : (
                    <button
                      className="btn action-btn"
                      style={{ backgroundColor: "#308888" }}
                      type="button"
                      onClick={() => {
                        setLock({ ...lock, sortingLock: true });
                        localStorage.setItem(
                          "booking-list-filter-sort-content",
                          dateType
                        );
                      }}
                    >
                      <AiFillUnlock
                        style={{ fontSize: "20px", margin: "0 5px" }}
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="nested p-lg-0 ">
              <div className="">
                <select
                  className="form-control filter-sec"
                  id="lead_status"
                  value={corporate}
                  onChange={(e) => {
                    setCorporate(e.target.value);
                  }}
                >
                  <option value="">Choose Corporate</option>
                  <option value="PERIFERRY">Periferry</option>
                  <option value="PERIFERRY06">Periferry06</option>
                  <option value="JELLY2D8">Jellyfish</option>
                  <option value="BHUMIX01">Bhumi</option>
                  <option value="CredXMano">Credences</option>
                  <option value="ManoSXUno">Unominda</option>
                  <option value="ManoSXFUJI">Fuji</option>
                  <option value="MANOXSIFF">Siff</option>
                  <option value="MANOXSOF">Steel-o-fab</option>
                  <option value="MANOXDEHAT">Dehat</option>
                  <option value="MANOSHALATEAM">Manoshala</option>
                </select>

                {/* <div className="input-group-append ">
                {lock.sortingLock ? (
                  <button
                    className="btn action-btn"
                    style={{ backgroundColor: "#308888" }}
                    type="button"
                    onClick={() => {
                      setLock({ ...lock, sortingLock: false });
                      setDateType("");
                      localStorage.removeItem(
                        "booking-list-filter-sort-content"
                      );
                    }}
                  >
                    <AiFillLock style={{ fontSize: "20px", margin: "0 5px" }} />
                  </button>
                ) : (
                  <button
                    className="btn action-btn"
                    style={{ backgroundColor: "#308888" }}
                    type="button"
                    onClick={() => {
                      setLock({ ...lock, sortingLock: true });
                      localStorage.setItem(
                        "booking-list-filter-sort-content",
                        dateType
                      );
                    }}
                  >
                    <AiFillUnlock
                      style={{ fontSize: "20px", margin: "0 5px" }}
                    />
                  </button>
                )}
              </div> */}
              </div>
            </div>

            <div className="nested p-lg-0">
              <div className="d-flex justify-content-end">
                <button
                  className="btn action-btn search-btn"
                  type="button"
                  onClick={() => {
                    setPage(1);
                    fetchData();
                  }}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Booking Count */}

        {/* <div className="booking-text">
          Bookings we had in 24 hr : <span className="booking-count">{recentBookings}</span>
        </div> */}

        {/* Main secttion */}
        <div className="main-section">
          <table className="table">
            <thead>
              <tr>
                <th>Edit</th>
                <th>Booking Id</th>
                <th>Lead Name</th>
                <th>Expert Name</th>
                <th>Booking Date</th>
                <th>Booking Type</th>
                <th>Booking status</th>
                <th>View</th>
                <th>Delete</th>
                <th>Cancel</th>
              </tr>
            </thead>
            <tbody>
              {list && list.length > 0 ? (
                list.map((el: any) => (
                  <SingleBookingRow
                    key={el._id}
                    props={el}
                    id={el._id}
                    func={isNgodelete}
                  />
                ))
              ) : (
                <h1 className="no-data">No Data Found</h1>
              )}
            </tbody>
          </table>
        </div>
        <div className="row m-0 pagination pt-5">
          <div className="col-sm-6 p-lg-0">
            <p>
              Showing {(page - 1) * pageSize + 1} to{" "}
              {page * pageSize > totalBookings
                ? totalBookings
                : page * pageSize}{" "}
              of {totalBookings} entries
            </p>
          </div>
          <div className="col-sm-6 p-lg-0 text-right">
            <div className="btn-group" role="group">
              <button
                type="button"
                className={
                  page === 1
                    ? "btn action-btn disabledButton "
                    : "btn action-btn"
                }
                onClick={() => setPage(page - 1)}
                disabled={page === 1 ? true : false}
              >
                {"<< Previous"}
              </button>
              <button type="button" className="btn action-btn selected">
                {page}
              </button>
              <button
                type="button"
                className={
                  page === totalPages || totalPages === 0
                    ? "btn action-btn disabledButton "
                    : "btn action-btn"
                }
                onClick={() => setPage(page + 1)}
                disabled={
                  page === totalPages || totalPages === 0 ? true : false
                }
              >
                {"Next >>"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
